<div class="item">
  @if (setup()) {
    <ghs-item
      [item]="item"
      [flipped]="flipped()"
      ghs-pointer-input
      [count]="gameManager.itemManager.assigned(item)"
      [editionLabel]="gameManager.currentEdition()"
      [ngClass]="{ selected: (!dialog() && equipped() && true) || false, unavailable: !dialog() && bbBlocked() }"
    ></ghs-item>
  }

  @if (!setup()) {
    <ghs-item
      [item]="item"
      [count]="gameManager.itemManager.assigned(item)"
      [flipped]="flipped() && !countFlag(ItemFlags.flipped)"
      [slotsMarked]="slotsMarked(ItemFlags.slot)"
      [slotsBackMarked]="slotsMarked(ItemFlags.slotBack)"
      [editionLabel]="gameManager.currentEdition()"
      [interactive]="true"
      (clickedConsumed)="toggleFlag($event, ItemFlags.consumed)"
      (clickedFlip)="toggleFlag($event, ItemFlags.flipped)"
      (clickedSpent)="toggleFlag($event, ItemFlags.spent)"
      (clickedPersistent)="toggleFlag($event, ItemFlags.persistent)"
      (clickedSlot)="toggleFlagCount($event, ItemFlags.slot)"
      (clickedSlotBack)="toggleFlagCount($event, ItemFlags.slotBack)"
      [ngClass]="{
        filtered: !equipped(),
        unavailable: countFlag(ItemFlags.consumed) > 0 || bbBlocked(),
        owned: countFlag(ItemFlags.persistent) > 0
      }"
    ></ghs-item>
  }

  @if (isLootRandomItem()) {
    <span class="loot-random-item">
      <img src="./assets/images/fh/loot-token.png" />
    </span>
  }

  <a
    class="button-equip"
    [ngClass]="{ equipped: equipped(), disabled: !setup() || bbBlocked() }"
    ghs-pointer-input
    (singleClick)="toggleEquippedItem()"
    (doubleClick)="toggleEquippedItem(true)"
  >
    <img class="ghs-svg" src="./assets/images/check.svg"
  /></a>
</div>
